import React from 'react';
import { TMaterialTableColumns } from 'components/table/index.types';
import { withdraws as types } from '../../../../types';
import timeFormat from 'utils/time-format';
import { PendingTaskStatus } from '../../../../types/entities/pending-tasks';

const columns = (): TMaterialTableColumns<types.TWithdraws> => [
    {
        width: '50',
        key: 'id',
        title: 'No',
    },
    {
        key: 'createdAt',
        title: 'Transaction Date & Time',
        width: '150',
        render: (props) => {
            return <span>{timeFormat(props.rowData.createdAt)}</span>;
        },
    },
    {
        width: '50',
        key: 'nexTransactionId',
        title: 'Transaction ID',
    },
    {
        width: '50',
        key: 'nexUserId',
        title: 'User Name',
    },
    {
        width: '50',
        key: 'phoneNumber',
        title: 'Mobile Number',
    },
    {
        width: '100',
        key: 'amount',
        title: 'Amount',
    },
    {
        width: '50',
        key: 'approvalStatus',
        title: 'Approval Status',
        render: (props) => {
            const status = (() => {
                if (
                    props.rowData &&
                    props.rowData.approvalStatus !== null &&
                    typeof props.rowData.approvalStatus != 'undefined'
                ) {
                    switch (props.rowData.approvalStatus.toString()) {
                        case PendingTaskStatus.PENDING: {
                            return 'Pending Approval';
                        }
                        case PendingTaskStatus.Approved: {
                            return 'Approved';
                        }
                        case PendingTaskStatus.Rejected: {
                            return 'Rejected';
                        }
                        default:
                            return '';
                    }
                }
                return '';
            })();
            return <span>{status}</span>;
        },
    },
    {
        width: '50',
        key: 'adminEmail',
        title: 'Created By',
    },
];

export default columns;
